
import PhoneLink from './PhoneLink'

export default {
  extends: PhoneLink,
  inheritAttrs: false,
  data() {
    return {
      defaultIcon: 'mobile-android'
    }
  },
  methods: {
    onClick() {
      this.$tracker.trackEvent('phone_call', {
        category: 'contact',
        label: 'mobile'
      })
    }
  }
}
